module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.1880e391.png";